














import { CrudService } from "../core/services/crudService";
import { Settings, TenantSettings } from "../core/services/configService";
import { Format } from "../core/helpers/formatHelper";
import Vue from "vue";
import { DateHelper } from "../core/helpers/dateHelper";
import store from "../core/store";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";

import CzPage from "../components/cz/CzPage.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzLink from "../components/cz/CzLink.vue";
@Component({
  components: { CzPage, CzCard, CzLink },
})
export default class MyOrdersPage extends Vue {
  data: any = null;
  errorMsg: string = "";
  infoReturns: any = null;
  reload: number = 1;
  settings: TenantSettings = {};

  async mounted() {
    this.settings = store.state.settings;
    let cid = 0;
    try {
      cid = JSON.parse(LocalStorage.getWithTimeout("cc")).id;
    } catch {
      console.error("not customer logged found");
    }

    await this.loadData(cid);
  }

  async loadData(customerId: number) {
    let url = `${Settings.HostName}/api/shop/customer-orders/${customerId}`;
    let data = await new CrudService().httpGet(url);
    if (data == null || data.ok === false) {
      console.error("Crash getting Your Orders");
      return;
    }

    this.data = data.model;
  }



  formatPrice(price: string) {
    return Format.formatCurrency(price);
  }

  itemNames(order: any) {
    return order.items.map((i: any) => i.name).join(" · ");
  }

  getDateFormatted(dt: string) {
    return DateHelper.formatDate(new Date(dt)).split(" ")[0];
  }
}
